Object.defineProperty(exports, "__esModule", {
  value: true
});
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
var MAX_SPECIFICITY = 20;

exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
exports.MAX_SPECIFICITY = MAX_SPECIFICITY;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-with-styles-interface-css/dist/utils/constants.js
// module id = 4323
// module chunks = 168707334958949